module.exports = __webpack_public_path__ + "static/img/s14.c755483d.png";